// extracted by mini-css-extract-plugin
export var hidden = "_sk-0";